﻿// BINDINGS

import type { LabelledConfiguration } from "@/components/platform/common/labelling";
import type { EnumLocaleAwareField } from "@/app/services/extensions/localisationServiceExtended";
import { getLocaleAwareRule } from "@/components/composables/localisation";
import type { Location } from "vue-router";

export const isComponentVisible = (
  configuration: BaseInputConfiguration<any>
): boolean => {
  if (configuration.localeAwareField) {
    if (
      !(
        getLocaleAwareRule(configuration.localeAwareField)?.isApplicable ?? true
      )
    ) {
      return false;
    }
  }

  if (configuration.isVisible === undefined) {
    return true;
  }
  return configuration.isVisible instanceof Function
    ? configuration.isVisible()
    : configuration.isVisible;
};

//#region CAPABILITIES

export interface Hideable {
  isVisible?: boolean | (() => boolean);
}

export type ValidationRule<T> = (value?: T) => boolean | string;

export interface Validatable<T> {
  rules?: ValidationRule<T>[] | (() => ValidationRule<T>[]);
}

export interface Readonly {
  readOnly?: boolean | (() => boolean);
}

export interface Routeable {
  routerLocation?: Location;
}

export interface LocaleAware {
  localeAwareField?: EnumLocaleAwareField;
}

//#endregion

//#region INPUT CONFIGURATION

export type BaseInputConfiguration<T> = LabelledConfiguration &
  Hideable &
  Validatable<T> &
  Readonly &
  LocaleAware &
  Routeable;

//#endregion

//#region CONTROL PROPS

export interface BaseControlProps<T> {
  value?: T;
  rules?: ValidationRule<T>[];
  readOnly?: boolean | (() => boolean);
  localeAwareField?: EnumLocaleAwareField;
  routerLocation?: Location;
}

//#endregion
